<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <g clip-path="url(#chevron-left__a)">
    <path d="M18.791 21.735a1 1 0 0 0 0-1.416L10.457 12l8.334-8.32a1 1 0 0 0 0-1.415L17.228.705a1 1 0 0 0-1.413 0L5.209 11.292a1 1 0 0 0 0 1.416l10.606 10.587a1 1 0 0 0 1.413 0l1.563-1.56Z"/>
  </g>
  <defs>
    <clipPath id="chevron-left__a">
      <path d="M0 0h24v24H0z"/>
    </clipPath>
  </defs>
</svg>
